import React from 'react'; 
import { FavoriteItem } from '../types'

interface FavoritesContext {
	savedFavorites: FavoriteItem[];
	setSavedFavorites: ( favorites: FavoriteItem[]) => void;
}

export const FavoritesContext = React.createContext<FavoritesContext>(null);